export default __webpack_public_path__ + "static/media/4123.13eb561b.png";